import axios, { AxiosError } from "axios";

// Définir un type pour les données de la réponse attendue
interface ResponseData {
  message?: string;
  // Ajoute d'autres propriétés que tu attends dans la réponse
}

export const handleAxiosError = (error: AxiosError<ResponseData>) => {
  // Cas où la réponse du serveur a été reçue
  if (error.response) {
    // Traiter en fonction du code de statut de la réponse
    switch (error.response.status) {
      case 400:
        // Mauvaise requête - Données invalides ou mal formées
        throw new Error("une erreur est survenue");
        break;
      case 401:
        // Non autorisé - Par exemple, token d'authentification invalide ou manquant
        throw new Error("une erreur est survenue");
        break;
      case 403:
        // Accès interdit - L'utilisateur n'a pas le droit d'accéder à la ressource
        throw new Error("une erreur est survenue");
        break;
      case 404:
        // Ressource non trouvée
        throw new Error("une erreur est survenue");
        break;
      case 500:
        // Erreur interne du serveur
        throw new Error("une erreur est survenue");
        break;
      default:
        // Autres codes d'erreur HTTP
        throw new Error("une erreur est survenue");
    }
  }
  // Cas où la requête a été envoyée mais ne peut pas atteindre le serveur (par exemple problème réseau)
  else if (error.request) {
    throw new Error("une erreur est survenue");
  }
  // Cas d'annulation de la requête
  else if (axios.isCancel(error)) {
    throw new Error("une erreur est survenue");
  }
  // Autres erreurs liées à Axios (par exemple, problème de configuration)
  else {
    // Ici on cast `error` comme un objet contenant un message
    throw new Error("une erreur est survenue");
  }
};